import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { GlobalModalProvider } from '@creditsights/styleguide-web';
import Base from './Base';
import './scss/styles.scss';
import { GlobalToastProvider } from './components/GlobalToaster/GlobalToastProvider';
import { queryKeys } from './hooks/queryKeyFactory';
import { creditsightsSyncDataSubject$, SyncDataSubject } from './sharedSubjects';

const queryClient = new QueryClient();

export default function Index(): React.ReactElement {
  useEffect(() => {
    const creditsightsSubject = creditsightsSyncDataSubject$.subscribe((subject) => {
      switch (subject) {
        case SyncDataSubject.USER_PREFERENCE:
          queryClient.invalidateQueries();
          break;
        case SyncDataSubject.USER_PROFILE:
          queryClient.invalidateQueries([queryKeys.fetchProfile]);
          break;
        default:
          break;
      }
      if (subject) {
        creditsightsSyncDataSubject$.next(null);
      }
    });

    return () => {
      creditsightsSubject.unsubscribe();
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalModalProvider>
        <GlobalToastProvider>
          <Base />
        </GlobalToastProvider>
      </GlobalModalProvider>
    </QueryClientProvider>
  );
}
